import { AxiosRequestConfig, AxiosResponse } from 'axios';
import api from "./api";

interface ApiCallbacks<T = unknown> {
  onSuccess?: (data: T) => void;
  onError?: (error: unknown) => void;
}

const handleRequest = async <T = unknown>(
  requestFn: () => Promise<AxiosResponse<T>>,
  onSuccess?: (data: T) => void,
  onError?: (error: unknown) => void
): Promise<T> => {
  try {
    const response = await requestFn();
    if (onSuccess) onSuccess(response.data);
    return response.data;
  } catch (error) {
    console.warn("[API Error]:", error);
    if (onError) onError(error);
    throw error;
  }
};

const apiService = {
  get: <T = unknown>(url: string, config: AxiosRequestConfig = {}, callbacks: ApiCallbacks<T> = {}): Promise<T> =>
    handleRequest<T>(
      () => api.get<T>(url, config),
      callbacks.onSuccess,
      callbacks.onError
    ),

  post: <T = unknown, D = unknown>(url: string, data: D = {} as D, callbacks: ApiCallbacks<T> = {}, config: AxiosRequestConfig = {}): Promise<T> =>
    handleRequest<T>(
      () => api.post<T>(url, data, config),
      callbacks.onSuccess,
      callbacks.onError
    ),

  put: <T = unknown, D = unknown>(url: string, data: D = {} as D, callbacks: ApiCallbacks<T> = {}, config: AxiosRequestConfig = {}): Promise<T> =>
    handleRequest<T>(
      () => api.put<T>(url, data, config),
      callbacks.onSuccess,
      callbacks.onError
    ),

  patch: <T = unknown, D = unknown>(url: string, data: D = {} as D, callbacks: ApiCallbacks<T> = {}, config: AxiosRequestConfig = {}): Promise<T> =>
    handleRequest<T>(
      () => api.patch<T>(url, data, config),
      callbacks.onSuccess,
      callbacks.onError
    ),

  delete: <T = unknown>(url: string, config: AxiosRequestConfig = {}, callbacks: ApiCallbacks<T> = {}): Promise<T> =>
    handleRequest<T>(
      () => api.delete<T>(url, config),
      callbacks.onSuccess,
      callbacks.onError
    ),
};

export default apiService;
